import { Footer } from 'components/Footer'
import { Header } from 'components/Header'
import { NextPage } from 'next'
import { NextSeo } from 'next-seo'
import { useIntl } from 'react-intl'
import { Testimonials } from 'views/testimonials'

const TestimonialsPage: NextPage = () => {
  const { formatMessage } = useIntl()

  return (
    <>
      <NextSeo
        title={formatMessage({ id: 'testimonials.meta.title' })}
        description={formatMessage({ id: 'testimonials.meta.description' })}
      />
      <Header bordered={false} />
      <Testimonials />
      <Footer />
    </>
  )
}

export default TestimonialsPage
